import { useMemo } from 'react'

export default function useConstant(constantValue) {
  return useMemo(() => constantValue, [])
}
